module.exports = "data:image/svg+xml;base64,PHN2ZyBoZWlnaHQ9IjQiIHZpZXdCb3g9IjAgMCA0IDQiIHdpZHRoPSI0IiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciPjxwYXRoIGZpbGw9IiMwMDczQzIiIGQ9Im0xOS42MDggMzEuMTI4YzAgLjkyOC0uNzg0IDEuNzEyLTEuNzI4IDEuNzEycy0xLjcyOC0uNzg0LTEuNzI4LTEuNzEyYzAtLjk0NC43ODQtMS43MjggMS43MjgtMS43MjhzMS43MjguNzg0IDEuNzI4IDEuNzI4eiIgZmlsbC1ydWxlPSJldmVub2RkIiB0cmFuc2Zvcm09InRyYW5zbGF0ZSgtMTYgLTI5KSIvPjwvc3ZnPgo="


//////////////////
// WEBPACK FOOTER
// ../core/src/assets/images/global-current.svg
// module id = 272
// module chunks = 0